import { CaseModel, ExpenditureModel, OutcomeClaimModel, WorkItemModel } from '@api/models';

export function caseKeysFilter(_case: CaseModel | ExpenditureModel | OutcomeClaimModel  = {}) {
  const { parentOrganizationalUnitKey: caseOrgKey = 0, parentCaseKey: caseKey = 0, parentClientKey: clientKey } = _case;
  return { caseOrgKey, caseKey, clientKey };
}
